export const RESPONSE_STATUS_CODES = {
    UNAUTHORIZED: 401,
};
